export default function Loader() {
  return (
    <div className="overlay">
      <div className="loader" />
    </div>
  );
}
